import React from 'react'

const PlayIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width :"24"} height={props.height ? props.height : "24"} fill="none" viewBox="0 0 24 24" {...props}>
    <path fill={props.fill ? props.fill : "#0D1536"} fillOpacity={props.fillOpacity ? props.fillOpacity : ".65"} d="M19.255 13.542L6.799 20.755c-.994.576-1.799.101-1.799-1.06V5.305c0-1.161.805-1.636 1.799-1.06l12.456 7.213c.993.575.993 1.508 0 2.084z"/>
  </svg>
)

export default PlayIcon
  